import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OnboardingProductsStore } from '../../../store/store';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TermsAndConditionsManagerCreateActions, TreActions, UiActions } from '../../../store/actions';
import { DataNotClientService } from '../../../services/data-not-client.service';
import { DataClientService } from 'src/app/services/data-client.service';
import { LoadingService } from '../../../services/loading.service';
import { SessionService } from '../../../services/session.service';
import { RequestTermsAndConditionsManagerCreate, RequestTre, ResponseTermsAndConditionsManagerCreate } from 'src/app/shared/interfaces';
import { RedirectService } from 'src/app/services/redirect.service';
import { ApiResponseStatus, StepsNotClientTypes, StepsClientTypes } from '../../../shared/enums';
import { environment } from 'src/environments/environment';
import { AccountFormatService } from 'src/app/services/account-format.service';
import { DatadogService } from 'src/app/services/datadog/datadog.service';
import { TagPage } from 'src/app/store/actions/ui.actions';
import { TermsConditionsHandler } from './handler/terms-conditions.handler';
import { ResponseTermsConditions } from 'src/app/shared/interfaces/termsConditions.interface';
import { ContextService } from 'src/app/services/context.service';
import { EnumService } from 'src/app/services/enum.service';


@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['../../../global.scss', './terms-conditions.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TermsConditionsComponent implements OnInit, OnDestroy {
  formData: FormGroup;
  formDataTerms: FormGroup;
  formDataUpdate: FormGroup;
  isProspect: boolean;
  privateMode: boolean;
  email: string;
  pageTitle: string;
  channelName: string;
  texts: ResponseTermsConditions;
  dataService: DataClientService | DataNotClientService;
  staticAssetsUrl = environment.staticScripts.staticAssets;

  treSubscription$ = this.store.pipe(
    select(OnboardingProductsStore.selectors.tre)
  );

  termsAndConditionsManagerCreate$ = this.store.pipe(
    select(OnboardingProductsStore.selectors.termsAndConditionsManagerCreate)
  );

  constructor(
    public loadingService: LoadingService,
    public sessionService: SessionService,
    private _fb: FormBuilder,
    private enumService: EnumService,
    private contextService: ContextService,
    private dataDogService: DatadogService,
    private redirectService: RedirectService,
    private dataClientService: DataClientService,
    private dataNotClientService: DataNotClientService,
    private accountFormatService: AccountFormatService,
    private termsConditionsHandler: TermsConditionsHandler,
    private store: Store<OnboardingProductsStore.AppState>
  ) {
    this.formDataTerms = this._fb.group({
      isAcceptTerms: [false, Validators.requiredTrue]
    });
    this.formDataUpdate = this._fb.group({
      isAcceptTermsUpdate: ['', [Validators.required, Validators.requiredTrue]]
    });
  }

  treSubscription = this.treSubscription$.subscribe(({ response, error }) => {
    if (!response) {
      return;
    }

    if (error) {
      this.dataDogService.addCustomError(error, 'ABR4 authentication error', environment.mode, { channel: 'not client' });
      return this.handleErrorTre(TreActions);
    }

    if (response) {
      this.handleWhiteContainer('block');
      if (response.client.operationState.code === ApiResponseStatus.OK) {
        this.dataDogService.addCustomEvent('Authenticated ABR4', environment.mode, { channel: 'not client' });
        this.loadingService.loading = false;
        this.store.dispatch(TreActions.cleanState());
      } else {
        this.dataDogService.addCustomError(error, 'ABR4 authentication Fail', environment.mode, { channel: 'not client' });
        this.store.dispatch(TreActions.cleanState());
        return this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_SUCURSAL_DERIVATION }));
      }
    }
  });

  termsAndConditionsManagerCreateSuscription = this.termsAndConditionsManagerCreate$.subscribe(({ response, error }) => {
    // error case
    if (error != null) {
      this.redirectService.setRedirect(StepsNotClientTypes.STEP_PUBLIC_LANDING);
      this.store.dispatch(TermsAndConditionsManagerCreateActions.cleanState());
      this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_SERVICE_ERROR }));
    }
    if (response) {
      let nextStep = StepsNotClientTypes.STEP_SERVICE_ERROR;
      this.store.dispatch(TermsAndConditionsManagerCreateActions.cleanState());
      if (response.client && response.client.operationState.code === ApiResponseStatus.OK) {
        if (environment.mode === 'WEB-PF') {
          if ((this.dataService.clientIsForeign() || this.dataService.jointIsForeign())) {
            nextStep = StepsNotClientTypes.STEP_CONTRACT_SIGNING;
          } else {
            nextStep = StepsNotClientTypes.STEP_CREATE_PRODUCT;
          }
        } else if (environment.mode === 'WEB') {
          nextStep = StepsNotClientTypes.STEP_CREATE_PRODUCT;
        }
      } else {
        nextStep = StepsNotClientTypes.STEP_SERVICE_ERROR;
      }
      this.store.dispatch(UiActions.Navigate({ step: nextStep }));
    }
  });

  ngOnInit() {
    if (this.contextService.isPublicOmni1()) {
      this.handleWhiteContainer('none');
      this.callTre();
    }
    this.setService();
    this.accountFormatService.getAccountNameFromAssets().subscribe((accountTitle) => {
      this.pageTitle = accountTitle;
    });
    if (this.privateMode) {
      this.channelName = 'client';
      this.email = this.dataService.getEmail();
    } else {
      this.channelName = 'not client';
      this.isProspect = this.dataNotClientService.getIsProspect();
      if (!this.isProspect) {
        this.formDataUpdate.controls['isAcceptTermsUpdate'].setValidators([Validators.required, Validators.requiredTrue]);
      }
    }
    setTimeout(() => {
      this.loadingService.loading = this.contextService.isPublicOmni1();
    }, 100);
    this.dataDogService.addCustomEvent('Terms and conditions', environment.mode, { channel: this.channelName });
    this.termsConditionsHandler.getTexts().subscribe((data) => {
      this.texts = data;
    });
  }

  ngOnDestroy() {
    this.termsAndConditionsManagerCreateSuscription.unsubscribe();
  }

  setService() {
    this.privateMode = environment.mode === 'IN' || environment.mode === 'PF' ? true : false;
    this.dataService = this.privateMode ? this.dataClientService : this.dataNotClientService;
    const googleAnalytics = {
      is_joint_account: this.dataService.isIsJointAccount(),
      job_information: {
        workActivityType: this.dataService.getWorkActivityType() ? this.dataService.getWorkActivityType() : 'No informado',
        dateEntryWork: this.dataService.getDateEntryWork() ? this.dataService.getDateEntryWork() : 'No informado',
        companyName: this.dataService.getCompanyName() ? this.dataService.getCompanyName() : 'No informado',
        rucCompany: this.dataService.getRucCompany() ? this.dataService.getRucCompany() : 'No informado',
        profession: this.dataService.getProfession() ? this.dataService.getProfession() : 'No informado'
      },
      currency_account_type: this.dataService.getCurrencyType()
    };
    this.store.dispatch(TagPage({text: 'contract-confirmation', extras: googleAnalytics}));
  }

  callTre() {
    const request: RequestTre = {};
    this.store.dispatch(TreActions.getTre({ request }));
  }

  handleErrorTre(action) {
    this.store.dispatch(action.cleanState());
    return this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_SERVICE_ERROR }));
  }

  continue() {
    this.loadingService.loading = true;

    if (this.privateMode) {
      const nextStep = environment.isMobile ? StepsClientTypes.STEP_CLIENT_SOFTOKEN_VU : StepsClientTypes.STEP_CREATE_PRODUCT;
      this.store.dispatch(UiActions.Navigate({ step: nextStep }));
    } else {
      const request: RequestTermsAndConditionsManagerCreate = {
        isAcceptTerms: this.formDataTerms.controls['isAcceptTerms'].value
      };
      this.store.dispatch(TermsAndConditionsManagerCreateActions.getTermsAndConditionsManagerCreate({ request }));
    }
  }

  checkForeign(response: ResponseTermsAndConditionsManagerCreate): boolean {
    const foreign = this.dataService.clientIsForeign() || this.dataService.jointIsForeign() ? true : false;
    return response.client && response.client.operationState.code === ApiResponseStatus.OK && foreign;
  }

  // Metodo para ocultar o mostrar el contenedor blanco - recordar solo usar 'none' o 'block'
  handleWhiteContainer(canShow: string) {
    const inputElement = document.getElementById('white-container');
    inputElement.style.display = canShow;
  }

  checkContract() {
    const name = this.accountFormatService.getName();
    let link = '';
    switch (name) {
      case 'Ahorro':
        link = this.dataService.isIsJointAccount() ?
          `${this.staticAssetsUrl}pdf/contracts/ahorro_clasico_mancomunado.pdf` :
          `${this.staticAssetsUrl}pdf/contracts/ahorro_clasico_individual.pdf`;
        break;
      case 'Flex':
        link = this.dataService.isIsJointAccount() ?
          `${this.staticAssetsUrl}pdf/contracts/contrato_cartilla_cuenta_ahorro_banco_falabella_mancomunado.pdf` :
          `${this.staticAssetsUrl}pdf/contracts/contrato_cartilla_cuenta_ahorro_banco_falabella.pdf`;
        break;
      case 'CTS':
        link = `${this.staticAssetsUrl}pdf/contracts/cts.pdf`;
        break;
      case 'AhorroSueldo':
        link = `${this.staticAssetsUrl}pdf/contracts/contrato_cartilla_cuenta_ahorro_sueldo_banco_falabella.pdf`;
        break;
    }
    window.open(link, '_blank');
  }
}
